export const getTimeZoneOffset = (caseCreatedAt: string): string => {
  const offset = new Date(caseCreatedAt).getTimezoneOffset();
  const sign = offset > 0 ? "-" : "+";
  const hours = Math.abs(Math.trunc(offset / 60))
    .toString()
    .padStart(2, "0");
  const minutes = Math.abs(offset % 60)
    .toString()
    .padStart(2, "0");
  return `${sign}${hours}${minutes}`;
};
